import React, { useState, useMemo } from "react";
import { Form, Formik } from "formik";
import http from "services/httpService";
import { SideNav } from "components";
import {
  MainBody,
  PageTitle,
  OverlayLoader,
  LargeButton,
  Ptag
} from "components/core";
import UploadFile from "components/UploadFile";
import { WidthLimiter } from "pages/PlanSetup/styles";
import { Divider } from "@mui/material";
import { useLocation } from "react-router";
import useFlex from "hooks/useFlex";
import { ErrorTag, TableData } from "./styles";

const FlexUploadDocuments = () => {
  const { state } = useLocation();
  const { next, getProductDetails } = useFlex();
  const [isLoading, setLoading] = useState(false);
  const [productId, setProductId] = useState();
  const [documentId, setDocumentId] = useState();
  const [uploadErrorData, setUploadErrorData] = useState([]);
  const [fileError, setFileError] = useState({
    productError: false,
    documentError: false,
  });
  const productDetails = useMemo(() => getProductDetails(state.product), []);
  const handleSubmit = async () => {
    const enrollment_id_list = localStorage.getItem("enrollmentIdList");
    handleError();
    if (!productId || !documentId) return;
    try {
      setLoading(true);
      let { data } = await http.post(
        "/business/product_wise_employee_data_upload/",
        {
          userplan_id: localStorage.getItem("flex_userplan_id"),
          employee_product_sheet_id: productId,
          employee_policy_doc_id: documentId,
          enrollment_id_list: JSON.parse(enrollment_id_list) || null,
        }
      );
      console.log(data);
      next();
    } catch (ex) {
      console.log(ex);
      if (ex.response && Array.isArray(ex.response.data)) {
        setUploadErrorData(
          (ex.response &&
            Array.isArray(ex.response.data) &&
            ex.response.data) ||
            []
        );
      } else {
        alert(ex.response.data);
      }
    } finally {
      setLoading(false);
    }
    return;
  };
  const handleError = () => {
    setFileError((prevState) => ({
      ...prevState,
      productError: !productId,
      documentError: !documentId,
    }));
  };

  const downloadExcel = async () => {
    const flexUserplanId = localStorage.getItem("flex_userplan_id");
    const payload = {
      plan_id: flexUserplanId,
    };
    const { data } = await http.post(
      "business/product_employee_sheet_skeleton/",
      payload,
      { responseType: "blob" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "employee_sheet.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };

  return (
    <section>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav />
          <MainBody>
            <WidthLimiter>
              <PageTitle title={`Setup ${productDetails.display_name}`} />
              {/* <Formik enableReinitialize={true} onSubmit={handleSubmit}>
                {() => (
                  <Form> */}
              <UploadFile
                label="Upload Employee Sheet"
                text="Upload Excel"
                sampleFile="FlexEmployeeSheet"
                showError={fileError.productError}
                productType="ghi"
                onSelect={setProductId}
                format="excel"
                type="employees_excel"
                onDownload={downloadExcel}
              />
              {!!uploadErrorData.length && (
                <ErrorTag>
                  <Ptag
                    color="#F27576"
                    style={{
                      paddingBottom: "12px",
                      height: "19px",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    Errors!
                  </Ptag>
                  <div>
                    <table
                      border="0.4px"
                      frame="void"
                      rules="all"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <TableData>
                            <Ptag
                              style={{
                                height: "10px",
                                fontWeight: "600",
                                textAlign: "center",
                              }}
                            >
                              ROW
                            </Ptag>
                          </TableData>
                          <TableData>
                            <Ptag
                              style={{
                                height: "10px",
                                fontWeight: "600",
                                textAlign: "center",
                              }}
                            >
                              COLUMN
                            </Ptag>
                          </TableData>
                          <TableData>
                            <Ptag
                              style={{
                                paddingLeft: "3px",
                                width: "24px",
                                height: "14px",
                                fontWeight: "600",
                              }}
                            >
                              MESSAGE
                            </Ptag>
                          </TableData>
                        </tr>
                      </thead>
                      <tbody>
                        {uploadErrorData.map((error, index) => (
                          <tr>
                            <TableData>
                              <Ptag
                                textAlign="center"
                                style={{ fontSize: "12px", fontWeight: "500" }}
                              >
                                {error?.Employee_no || ""}
                              </Ptag>
                            </TableData>
                            <TableData>
                              <Ptag
                                textAlign="center"
                                style={{ fontSize: "12px", fontWeight: "500" }}
                              >
                                {error?.column || ""} {"  "}
                              </Ptag>
                            </TableData>
                            <TableData>
                              <Ptag
                                style={{ fontSize: "12px", fontWeight: "600" }}
                              >
                                {error?.error || ""}
                              </Ptag>
                            </TableData>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </ErrorTag>
              )}

              <Divider />
              <UploadFile
                label="Upload Benefit Manual"
                text="Upload PDF"
                format="pdf"
                type="policy_document"
                onSelect={setDocumentId}
                showError={fileError.documentError}
              />

              <div style={{ bottom: "2rem" }}>
                <LargeButton
                  type="submit"
                  label="Save & Next"
                  marginTop="2rem"
                  onClick={handleSubmit}
                />
              </div>
              {/* </Form>
                )}
              </Formik> */}
            </WidthLimiter>
          </MainBody>
        </>
      )}
    </section>
  );
};

export default FlexUploadDocuments;
